import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import './gallery.scss';

const Gallery = ({ images }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const prevIndex = (photoIndex + images.length - 1) % images.length;
  const nextIndex = (photoIndex + 1) % images.length;

  return (
    <div className="gallery">
      {images.map((image, index) => {
        return (
          <a
            className="gallery__link"
            href={image.childImageSharp.full.src}
            key={image.childImageSharp.full.src}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setPhotoIndex(index);
              setLightboxOpen(true);
            }}
          >
            <img src={image.childImageSharp.thumb.src} alt="Box One" />
          </a>
        );
      })}

      {lightboxOpen && (
        <Lightbox
          mainSrc={images[photoIndex].childImageSharp.full.src}
          nextSrc={images[nextIndex].childImageSharp.full.src}
          prevSrc={images[prevIndex].childImageSharp.full.src}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() => setPhotoIndex(prevIndex)}
          onMoveNextRequest={() => setPhotoIndex(nextIndex)}
        />
      )}
    </div>
  );
};

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Gallery;
